import React from 'react'
import ListPage from '../../components/ListPage';
const Services=()=> {

    const ListContent=[
        "Circulation Service",
        "Reference Service",
        "Online Reservation",
        "OPAC (Online Public Access Catalogue)",
        "NPTEL",
        "Overnight Circulation",
        "Organizing Book Exhibition",
        "News Paper Clippings",
        "Remote Access for all the resources like Knimbus (E-Journals, E-Books)",
        "NDLI Club Activities",
        "Orientation Program",
        ]
  return (
    <div>
       <ListPage
       Title='Services'
       ListContent={ListContent}
       
       />
    </div>
  )
}
export default Services